module.exports = __webpack_public_path__ + "static/media/HS870HJ.a7414bad.jpg";